export default __webpack_public_path__ + "static/media/asiacup-celes.954ba455.png";